export var version = '13.1.1';
// Note: This file is automatically generated when building math.js.
// Changes made in this file will be overwritten.